import * as toastr from 'toastr';
import * as React from "react";
// @ts-ignore
import * as uuid from 'uuid/v1';
import {connect} from 'react-redux';
import {mapStateToProps} from "./mapStateToProps";
import {mapDispatchToProps} from "./mapDispatchToProps";
import {MAX_BOUNDS} from "../../utils/maxBounds";
import {getPopupInfo, IPopupInfo} from "../../utils/getPopupInfo";
import {initViewport} from "../../utils/initViewport";
import {useViewport, ViewportProvider} from "./viewport";
import {getStyleUrl, styleKeys, styles} from "./utils";
import {Map, newEntityProperties} from "./map";
import {layerIsVisible} from "../../utils/layerIsVisible";
import {requestEntityInfo} from "../../http/requestEntityInfo";
import {requestFeatureInfo} from "../../http/requestFeatureInfo";
import {List} from "immutable";
import {dataLayer, dataLayerLineString, dataLayerPoint} from "../../store/reducers/loadMapStyle";
import {IContactNode, IFeature_CONO, IFeatureProperties, LayerVisibility} from "../../types";
import {createEntitycontact} from "../../http/createEntityContactLink";
import {deleteEntitycontactByObjectid} from "../../http/deleteEntityContactByObjectid";
import {createContact} from "../../http/createContact";
import {updateContactByPocid} from "../../http/updateContactByPocid";
// @ts-ignore
import getCenter from '@turf/center';
import DataControls from "../../components/data-controls";
import {RightControls} from "./rightControls";
import {MAPBOX_TOKEN, URL_CONFIG} from "../../config";
import LayerList from "../../components/layer-list";
import {Table} from "../table";
import AuthService from "../../../global/authService";
import {EditControls} from "../../components/edit-controls";
import {geometryIsValid, geometryValidationMessage} from "../../utils/geometryIsValid";
import {searchGeomEntitiesByLayer} from "../../http/searchEntitiesByGeomByLayer";
import {BufferModal} from "../../components/buffer-modal";
import {VerticalModal} from "../../components/modal";
import {bufferFeature} from "../../utils/buffer";
import {Contact} from "../../../types";
import {AnyAction} from "redux";
import LOGO from "../../../public/NAPD_round-logo.jpeg";
import {getLayerName} from "../../utils/getLayerName";
import {customSort} from "../../utils/customSort";
/**
 *
 * notifications won't close automatically
 *
 * */

toastr.options.closeButton = true;
toastr.options.timeOut = 0;
toastr.options.extendedTimeOut = 0;
toastr.options.tapToDismiss = false;

type IProps = {
    width: number;
    height: number;
}
type mapDispatchType = ReturnType<typeof mapDispatchToProps>;
type mapStateType = ReturnType<typeof mapStateToProps>;
export type IProps_Dispatch_State = IProps & mapDispatchType & mapStateType;

interface IState {
    data: any
    layerIds: any[]
    markers: any[]
    viewport: any
    maxBounds: typeof MAX_BOUNDS
    styleName: string
    popupInfo?: IPopupInfo
    userLocation: any
    showContactDetails: boolean
    temporaryFeatures: IFeature_CONO[]
    measureFeatures: IFeature_CONO[]
    originalFeature?: IFeature_CONO
    isCreatingNewEntity: boolean
    isEditingGeometry: boolean
    isEditingPopup: boolean
    isMeasuring: boolean
    isEditing: boolean
    showBuffer: boolean
    showModal: boolean
    modalTitle: string
    buffered: boolean
}

type IAction = {
    type: ACTION_TYPES
    [key: string]: any
}

const initial_state: IState = {
    data: undefined,
    layerIds: [],
    markers: [],
    viewport: initViewport,
    maxBounds: MAX_BOUNDS,
    styleName: styles.light,
    popupInfo: undefined,
    userLocation: undefined,
    showContactDetails: false,
    temporaryFeatures: [],
    measureFeatures: [],
    originalFeature: undefined,
    isCreatingNewEntity: false,
    isEditingGeometry: false,
    isEditingPopup: false,
    isMeasuring: false,
    isEditing: false,
    showBuffer: false,
    showModal: false,
    modalTitle: '',
    buffered: false
};

enum ACTION_TYPES {
    init=-1,
    updateViewport,
    closePopup,
    closeModal,
    setPopupInfo,
    setModalInfo,
    setTempFeatures,
    setMeasureFeatures,
    setUserLocation,
    setProperties,
    editGeometry,
    cancelEditing,
}

function boundViewport (state: IState, action: AnyAction): IState {
    const newViewport = {...state.viewport, ...action.viewport};
    const [[minLongitude, minLatitude],[maxLongitude, maxLatitude]] = MAX_BOUNDS;
    const minZoom = initViewport.zoom - 1;

    if (newViewport.longitude < minLongitude ) {
        newViewport.longitude = minLongitude;
    } else if ( newViewport.longitude > maxLongitude ) {
        newViewport.longitude = maxLongitude;
    }

    if ( newViewport.latitude < minLatitude ) {
        newViewport.latitude = minLatitude;
    } else if ( newViewport.latitude > maxLatitude ) {
        newViewport.latitude = maxLatitude;
    }

    // if (viewport.zoom < 6.5) {
    //     viewport.zoom = 6.8;
    // }

    if (newViewport.zoom < minZoom) {
        newViewport.zoom = minZoom;
    }
    state.viewport = newViewport;
    return state;
}
function closePopup (state: IState): IState {
    return {
        ...state,
        popupInfo: undefined,
        isCreatingNewEntity: false,
        isEditingGeometry: false,
        originalFeature: undefined,
        isEditingPopup: false
    }
}
function closeModal (state: IState): IState {
    return {
        ...state,
        showModal: false,
        modalTitle: '',
    }
}
function setPopupInfo (state: IState, action: AnyAction): IState {
    return {
        ...state,
        popupInfo: {
            ...action.popupInfo
        },
    }
}
function setModalInfo (state: IState, action: AnyAction): IState {
    const {
        showModal,
        modalTitle
    } = action;
    return {...state, showModal, modalTitle};
}
function setTempFeatures (state: IState, action: AnyAction): IState {
    const {temporaryFeatures = [], originalFeature} = action;
    const newState = {...state, temporaryFeatures};
    if (originalFeature !== undefined) Object.assign(newState, {originalFeature});
    return newState;
}
function setMeasureFeatures (state: IState, action: AnyAction): IState {
    const {measureFeatures} = action;
    return {...state, measureFeatures};
}
function setUserLocation (state: IState, action: AnyAction): IState {
    const {userLocation} = action;
    return {...state, userLocation};
}
function setProperties (state: IState, action: AnyAction): IState {
    const props = {...action, type: undefined};
    return {...state, ...props};
}
function editGeometry (state: IState, action: AnyAction): IState {
    const {isEditingGeometry} = action;
    return {...state, isEditingGeometry};
}
function cancelEditing (state: IState, action: AnyAction): IState {
    const {
        isCreatingNewEntity,
        isEditingGeometry,
        temporaryFeatures,
    } = action;
    return {
        ...state,
        isCreatingNewEntity,
        isEditingGeometry,
        temporaryFeatures,
    };
}
function mapReducer (state= initial_state, action: IAction): IState {
    switch (action.type) {
        case ACTION_TYPES.updateViewport:
            return boundViewport(state, action);
        case ACTION_TYPES.closePopup:
            return closePopup(state);
        case ACTION_TYPES.closeModal:
            return closeModal(state);
        case ACTION_TYPES.setPopupInfo:
            return setPopupInfo(state, action);
        case ACTION_TYPES.setModalInfo:
            return setModalInfo(state, action);
        case ACTION_TYPES.setTempFeatures:
            return setTempFeatures(state, action);
        case ACTION_TYPES.setMeasureFeatures:
            return setMeasureFeatures(state, action);
        case ACTION_TYPES.setUserLocation:
            return setUserLocation(state, action);
        case ACTION_TYPES.editGeometry:
            return editGeometry(state, action);
        case ACTION_TYPES.setProperties:
            return setProperties(state, action);
        case ACTION_TYPES.cancelEditing:
            return cancelEditing(state, action);
        case 9:
        // case 'ADD': return { count: state.count + 1 };
        // case 'SUB': return { count: state.count - 1 };
        // eslint-disable-next-line no-fallthrough
        default:
            return state;
    }
}
function noop () {}
export function MapContainer (props: IProps_Dispatch_State) {
    const [state, dispatch] = React.useReducer(mapReducer, initial_state);
    const [modalCompleteFn, setModalCompleteFn] = React.useState(() => noop)
    const [userPoint, setUserPoint] = React.useState<any>();
    const [toastrObject, setToastrObject] = React.useState();
    const {
        /* props */
        width, height,
        isEditing, layerState, layers, mapStyle, databaseLayerIds, interactiveLayerIds, editMode,
        /* display stuff */
        showLayerList, showTable,
        /* callbacks */
        selectFeature, selectFeatures, setSinglePoint,
        toggleLayerList, toggleTable, toggleLayerVisibility,
        /* http */
        deleteFeature, createFeature, updateFeature, updateFeatureGeometry,
        deleteFeatureShallow, createFeatureShallow,
        requestMapStyle, requestGeometry, setEditing,
        updateLayerName, createLayer, deleteLayer, createMeasurementLayer,
    } = props;
    const {
        /* state */
        userLocation, temporaryFeatures, measureFeatures, modalTitle,
        originalFeature, popupInfo, styleName,
        isCreatingNewEntity, isMeasuring, isEditingGeometry, isEditingPopup,
        /* display state */
        showContactDetails, showModal, showBuffer,
    } = state;

    const {
        viewport,
        updateViewport: onViewportChange,
    } = useViewport();

    const sortedLayers = React.useMemo(() => {
        return layers.sort((layerA: string, layerB: string) => {
            const nameA = getLayerName(layerA, layerState); // ignore upper and lowercase
            const nameB = getLayerName(layerB, layerState); // ignore upper and lowercase
            return customSort(nameA, nameB);
        });
    }, [layers, layerState])

    const sources = React.useMemo(() => {
            return mapStyle ? mapStyle.get('sources') : undefined
        }, [mapStyle]);
    const setTempFeatures = React.useCallback((temporaryFeatures, originalFeature?) => {
        dispatch({
            type: ACTION_TYPES.setTempFeatures, temporaryFeatures, originalFeature
        });
    }, [dispatch])

    const updateMeasurementLayer = React.useCallback((features: IFeature_CONO[]) => {
        let coords: [number, number][] = [];
        let i = -1;
        while (++i < features.length) {
            const feature = features[i];
            if (feature) {
                coords = coords.concat(features[i].geometry.coordinates.slice())
            }
        }
        if (coords.length > 0) {
            createMeasurementLayer(coords);
        }
    }, [createMeasurementLayer])

    const handleMeasureUpdate = React.useCallback(measureFeatures => {
        dispatch({
            type: ACTION_TYPES.setMeasureFeatures, measureFeatures
        })
        updateMeasurementLayer(measureFeatures);
    }, [updateMeasurementLayer])

    const resetTempFeature = React.useCallback(() => {
        const feature = originalFeature;
        if (feature) {
            const {fullUid, type} = popupInfo!;
            deleteFeatureShallow(fullUid!, feature.properties.type!);
            createFeatureShallow(fullUid!, feature, type!, feature.properties);
            selectFeature(feature);
        }
    }, [originalFeature, popupInfo, createFeatureShallow, deleteFeatureShallow, selectFeature])

    const closePopup = React.useCallback(() => {
        // resetTempFeature();
        dispatch({type: ACTION_TYPES.closePopup})
        selectFeature(null);
    }, [dispatch, selectFeature])
    const hideBuffer = React.useCallback(() => {
        dispatch({
            type: ACTION_TYPES.setProperties,
            showBuffer: false,
        })
    }, [dispatch])
    const showPopupForFeature = React.useCallback((feature) => {
        if (!feature || layers.indexOf(feature.properties.type) === -1) {
            return;
        }

        selectFeature(feature);
        const popupInfo = getPopupInfo(feature);
        const type = popupInfo.type!;
        if (!layerIsVisible(layerState, type)) {
            toggleLayerVisibility(type);
        }
        dispatch({type: ACTION_TYPES.setPopupInfo, popupInfo});
    }, [layerState, layers, dispatch, selectFeature, toggleLayerVisibility]);
    const closeModal = React.useCallback(() => {
        dispatch({
            type: ACTION_TYPES.closeModal,
        })
    }, [])
    const confirmModal = React.useCallback(() => {
        modalCompleteFn();
        setModalCompleteFn(() => noop);
        closeModal();
    }, [modalCompleteFn, closeModal, setModalCompleteFn])

    const _setUserPoint = React.useCallback((point?: any) => {
        setUserPoint(point);
        setSinglePoint(point);
    }, [setSinglePoint, setUserPoint]);

    const resolveFlyToFeature = React.useCallback((feature, pointGeometry, shouldFlyToFeature) =>  {
        if (feature.hasOwnProperty('feature')) {
            feature.geometry = feature.feature;
        }
        showPopupForFeature(feature);
        if (shouldFlyToFeature) {
            onViewportChange({
                latitude: pointGeometry.coordinates[1],
                longitude: pointGeometry.coordinates[0],
            });
        }
    }, [onViewportChange, showPopupForFeature]);

    const flyToFeature = React.useCallback(async (feature: IFeature_CONO, shouldFlyToFeature: boolean) => {
        let geometry;
        let center;
        try {
            const fullUid = feature.fullUid || feature.properties.fullUid;
            const entityInfo = await requestEntityInfo(fullUid)
            if (feature.geometry && feature.properties) {
                center = getCenter(feature.geometry);
                geometry = center.geometry;
                feature.properties = {...feature.properties, ...entityInfo[0]};
                resolveFlyToFeature(feature, geometry, shouldFlyToFeature);
            } else {
                const result: any = await requestFeatureInfo(fullUid)
                center = getCenter(result[0].feature);
                geometry = center.geometry;
                Object.assign(feature, result[0]);
                feature.properties = {...feature.properties, ...entityInfo[0]};
                resolveFlyToFeature(feature, geometry, shouldFlyToFeature);
            }
        } catch (e) {
            console.error(e);
        }
    }, [resolveFlyToFeature])

    const panToFeature = React.useCallback(async (feature, shouldFlyToFeature = true) => {
        closePopup();
        await flyToFeature(feature, shouldFlyToFeature);
    }, [closePopup, flyToFeature]);
    const resetMeasuring = React.useCallback(() => {
        const measureFeatures: [number, number][] = [];
        dispatch({
            type: ACTION_TYPES.setMeasureFeatures,
            measureFeatures,
        })
        createMeasurementLayer(measureFeatures);
    }, [dispatch, createMeasurementLayer])
    // @ts-ignore
    // const cancelMeasuring = React.useCallback(() => {
    //     dispatch({
    //         type: ACTION_TYPES.setProperties,
    //         isMeasuring: false,
    //     })
    //     resetMeasuring();
    // }, [dispatch, resetMeasuring]);
    const handleClick = React.useCallback(async (event) => {
        const target = event.target;
        if (target && target.className !== 'overlays') return;
        const {features} = event;
        if (!isEditing || showBuffer) {
            if (!features || features.length === 0) return;
            await panToFeature(features[0], false);
        }
    }, [isEditing, showBuffer, panToFeature])
    const handleContextMenu = React.useCallback((event) => {
        const target = event.target;
        if (target && target.className !== 'overlays') return;
        // handle context menus for multiple targets
        switch (event.target.className) {
            case 'user-select':
            case 'popup-user-select':
                break;
            // default case is map canvas
            default:
                event.preventDefault();
        }
    }, [])
    const handleDataControlsFeatureClick = React.useCallback((isDrawing, editMode) => {
        if (showContactDetails) return;
        const _editMode = editMode.toLowerCase();
        let feature: any = { "type": "Feature", "geometry": {}};
        let point;
        if (userPoint) {
            point = userPoint?.data?.features[0]?.geometry?.coordinates;
        }
        if (!point) {
            point = [viewport.longitude, viewport.latitude];
        }
        switch (_editMode) {
            case 'point':
                feature.geometry = { "type": "Point", "coordinates": point };
                break;
            case 'line':
                feature.geometry = { "type": "LineString", "coordinates": [point, point] };
                break;
            case 'polygon':
            default:
                feature.geometry = { "type": "MultiPolygon", "coordinates": [[[point, point, point]]] };
                break;
        }
        setTempFeatures([feature]);
        setEditing(isDrawing, _editMode);
    }, [showContactDetails, viewport, setEditing, setTempFeatures, userPoint]);
    const handleBuffer = React.useCallback(() => {
        dispatch({
            type: ACTION_TYPES.setProperties,
            showBuffer: true,
        })
    }, [dispatch])
    const handleMeasure = React.useCallback(() => {
        resetMeasuring();
        dispatch({
            type: ACTION_TYPES.setProperties,
            isMeasuring: !isMeasuring,
        })
    }, [isMeasuring, resetMeasuring, dispatch])
    const handleLogout = React.useCallback(() => {
        AuthService.logout();
        window.location.href = URL_CONFIG.homeUrl;
    },[]);
    const handleTempFeatureSave = React.useCallback(() => {
        if (isEditingGeometry) {
            // handle save, show temp geometry
            // this.geometryChanged = true;
            const {fullUid, type} = popupInfo!;
            const feature = temporaryFeatures[0];
            feature.properties.type = type;
            // this.props.updateFeatureGeometry(fullUid, type, {}, feature);
            deleteFeatureShallow(fullUid!, feature.properties.type!);
            createFeatureShallow(fullUid!, feature, type!, feature.properties);
            selectFeature(feature);
        } else {
            const popupInfo = getPopupInfo({
                ...temporaryFeatures[0],
                properties: newEntityProperties as IFeatureProperties
            });
            dispatch({
                type: ACTION_TYPES.setProperties,
                isCreatingNewEntity: true,
                isEditing: false,
                popupInfo,
            })
            const feature = temporaryFeatures[0];
            if (feature) selectFeature(feature);
            setEditing(false, '');
        }
    }, [
        popupInfo, temporaryFeatures, isEditingGeometry,
        dispatch, setEditing, deleteFeatureShallow, createFeatureShallow, selectFeature,
    ])

    const clearToast = React.useCallback(() => {
        if (toastrObject) {
            // @ts-ignore
            toastrObject.remove();
            setToastrObject(undefined);
        }
    }, [toastrObject, setToastrObject]);

    const handleTempFeatureQuery = React.useCallback(() => {
        const _layers = layers.filter((layer: string) => layerIsVisible(layerState, layer));
        const queryId = `cono_query_${uuid()}`;
        let feature = temporaryFeatures[0];
        if (feature.geometry.type === 'Point') {
            feature = bufferFeature(feature, 0.000015, 'feet');
        }
        // searchGeomEntitiesByLayer
        searchGeomEntitiesByLayer(feature, _layers).then(data => {
            const results = {
                title: `Results: ${data.length} Entities`,
                data
            };
            localStorage.setItem(queryId, JSON.stringify(results));
            clearToast();
            toastr.options.onclick = () => toastr.remove();
            const _toastrObject: any = toastr.info(
                `<a class="toastrLink" href="./#/query/${queryId}" target="_blank" rel="noopener noreferrer">
                    <span>Show Results (${data.length || 0}) </span>
                    <i class="fas fa-external-link-alt" />
              </a>`, 'Query',);
            setToastrObject(_toastrObject);
            selectFeatures(data);
        });
        setTempFeatures([]);
    }, [layerState, layers, temporaryFeatures, setToastrObject, clearToast, setTempFeatures, selectFeatures])

    const resize = React.useCallback(() => {
        onViewportChange({
            width: width || window.innerWidth,
            height: height || window.innerHeight,
        });
    }, [onViewportChange, height, width])
    const zoomIn = React.useCallback(() => {
        const zoom = viewport.zoom + 1;
        onViewportChange({
            zoom,
        });
    }, [onViewportChange, viewport.zoom])
    const zoomOut = React.useCallback(() => {
        const zoom = viewport.zoom - 1;
        onViewportChange({
            zoom,
        });
    },[onViewportChange, viewport.zoom])
    const resetViewport = React.useCallback(() => {
        onViewportChange({
            ...initViewport
        });
    }, [onViewportChange])
    const getNextBaseMap = React.useCallback(() => {
        const keys = styleKeys;
        let index = styleKeys.indexOf(styleName);
        if (index === styleKeys.length - 1) index = 0;

        while (index < keys.length) {
            if (keys[index] !== styleName) {
                return keys[index];
            }
            index++;
        }
    }, [styleName])
    const switchBasemap = React.useCallback(() => {
        const newStyleName = getNextBaseMap()!;
        requestMapStyle(getStyleUrl(newStyleName, MAPBOX_TOKEN), newStyleName);
        dispatch({type: ACTION_TYPES.setProperties, styleName: newStyleName});
    }, [getNextBaseMap, requestMapStyle])
    const locateUser = React.useCallback(() => {
        if (userLocation) {
            return dispatch({
                type: ACTION_TYPES.setUserLocation,
                userLocation: undefined
            });
        }
        // https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/Using_geolocation
        navigator.geolocation.getCurrentPosition(position => {
            onViewportChange({
                longitude: position.coords.longitude,
                latitude: position.coords.latitude
            });
            dispatch({
                type: ACTION_TYPES.setUserLocation,
                userLocation: position
            });
        });
    }, [dispatch, onViewportChange, userLocation])
    const toggleEditing = React.useCallback(() => {
        dispatch({
            type: ACTION_TYPES.setProperties,
            isEditingPopup: !isEditingPopup,
        })
    },[dispatch, isEditingPopup]);
    const bufferExistingFeature = React.useCallback((fullUid: string, editMode = 'bufferExisting') => {
        let features: List<any>;
        const searchKeyPath = ['properties', 'fullUid'];
        const source = popupInfo?.type;
        if (source) {
            features = mapStyle
                .getIn(['sources', source, 'data', 'features'])
                .filter((f: any) => f.getIn(searchKeyPath) === fullUid);
        } else {
            features = mapStyle
                .getIn(['sources', dataLayer.source, 'data', 'features'])
                .filter((f: any) => f.getIn(searchKeyPath) === fullUid);

            features = features.push(mapStyle
                .getIn(['sources', dataLayerPoint.source, 'data', 'features'])
                .filter((f: any) => f.getIn(searchKeyPath) === fullUid));

            features = features.push(mapStyle
                .getIn(['sources', dataLayerLineString.source, 'data', 'features'])
                .filter((f: any) => f.getIn(searchKeyPath) === fullUid));
        }

        if (features.size > 0) {
            const feature = features.get(0).toJS();
            setTempFeatures([feature], feature);
            setEditing(true, editMode);
        }
    }, [mapStyle, popupInfo, setTempFeatures, setEditing])
    const bufferTempFeature = React.useCallback((bufferAmount, units) => {
        const feature = temporaryFeatures[0];
        const buffered = bufferFeature(feature, bufferAmount, units);
        buffered.properties = {...buffered.properties, update: true};
        setTempFeatures([buffered]);
        hideBuffer();
        setEditing(true, 'bufferexisting');
    }, [temporaryFeatures, setTempFeatures, hideBuffer, setEditing])
    const beginEditGeometry = React.useCallback((fullUid) => {
        bufferExistingFeature(fullUid, '');
        dispatch({type: ACTION_TYPES.editGeometry, isEditingGeometry: true});
    },[bufferExistingFeature])
    const cancelEditing = React.useCallback(() => {
        clearToast();
        dispatch({
            type: ACTION_TYPES.cancelEditing,
            isCreatingNewEntity: false,
            isEditingGeometry: false,
            temporaryFeatures: isEditingGeometry ? temporaryFeatures : [],
        })
        setEditing(false, '');
        // selectFeature(null);
    }, [isEditingGeometry, temporaryFeatures, setEditing, clearToast])
    /* http */

    const _createEntityContactLink = React.useCallback(async (feature: IFeature_CONO, contact: Contact|IContactNode) => {
        try {
            const pocid = contact.pocid;
            const {properties} = feature;
            const fullUid = properties.id || properties.fullUid;
            if (fullUid && pocid && !isNaN(pocid)) {
                await createEntitycontact({
                    pocid,
                    fullUid
                });
                // feature.properties.contacts
                // const newContact = entityContact.contactByPocid;
                // newContact.entitycontactId = entityContact.objectid;
                // const center = getCenter(feature.geometry);
                // const geometry = center.geometry;
                // if (newContact) {
                //     feature.properties.contacts = feature.properties.contacts ?
                //         feature.properties.contacts.filter(
                //             ({pocid}) => pocid !== newContact.pocid
                //         ) : [];
                //     feature.properties.contacts.push(newContact);
                // }
                closePopup();
                // this._resolveFlyToFeature(feature, geometry, false);
            } else {
                console.error('invalid POC ID');
            }

        } catch (e) {
            console.error(e);
            toastr.error('Error adding contact');
        }
    }, [closePopup])

    const _removeEntityContactLink = React.useCallback(async (feature: IFeature_CONO, contact: IContactNode) => {
        try {
            const {entitycontactId} = contact;
            await deleteEntitycontactByObjectid(entitycontactId as number);
            closePopup();
        } catch (e) {
            toastr.error('Error removing contact');
        }
    }, [closePopup])

    const _createContact = React.useCallback(async (feature: IFeature_CONO, contactInfo: IContactNode) => {
        const {
            name,
            cell,
            land,
            email,
            pubconinfo,
            instruc
        } = contactInfo;
        const patch = {
            name,
            cell,
            land,
            email,
            pubconinfo,
            instruc
        };
        try {
            const contact = await createContact(patch);
            await _createEntityContactLink(feature, contact);
        } catch (e) {
            console.error(e);
            toastr.error('Error creating contact');
        }
    }, [_createEntityContactLink])

    const _editContact = React.useCallback(async (feature: IFeature_CONO, contactInfo: IContactNode) => {
        try {
            const {name, cell, land, email, pubconinfo, instruc, pocid} = contactInfo;
            const patch = {
                name, cell, land, email, pubconinfo, instruc
            };
            await updateContactByPocid(pocid as number, patch);
            // flyToFeature(popupInfo.feature, false);
            closePopup();
        } catch (e) {
            console.error(e);
            toastr.error('Error updating contact');
        }
    }, [closePopup])

    const _deleteFeature = React.useCallback((id: string, type: string) => {
        dispatch({
            type: ACTION_TYPES.setModalInfo,
            showModal: true,
            modalTitle: 'Delete Feature?'
        });

        setModalCompleteFn(() => () => {
            deleteFeature(id, type);
            selectFeature(null);
            closePopup();
        })
    }, [dispatch, closePopup, deleteFeature, selectFeature, setModalCompleteFn])

    const _replaceFeature = React.useCallback((fullUid: string, feature: IFeature_CONO, type: string) => {
        try {
            // const geoType = getGeoType(feature);
            // await deleteEntitygeometryByFullUid(fullUid);
            // createFeatureGeometry(geoType, type, fullUid, feature);
            updateFeatureGeometry(fullUid, type, {}, feature);
        } catch (e) {
            console.error(e);
        }
    }, [updateFeatureGeometry])

    const _updateFeature = React.useCallback(async (newPopupInfo: IPopupInfo & {oldType: string;}) => {
        let popupInfo = newPopupInfo;
        // const {isEditingGeometry} = this.state;
        const fullUid = popupInfo.fullUid;
        let feature = temporaryFeatures[0] || popupInfo.feature;
        const {type} = popupInfo;
        if (!type) {
            console.warn(`missing type for mapContainer.updateFeature: ${fullUid}`);
        }
        const {
            notes,
            instruc,
            address,
            city,
            state,
            zip,
            name,
            websiteurl,
            phone,
            email,
        } = popupInfo;
        const patch: any = {
            layerid: databaseLayerIds[type!],
            name,
            websiteurl,
            phone,
            email,
            notes,
            instruc,
            address,
            city,
            state,
            zip,
        };
        if (popupInfo.membertype) {
            patch.membertype = popupInfo.membertype;
        }

        if (fullUid) {
            if (originalFeature) {
                // UPDATE FEATURE GEOMETRY
                await _replaceFeature(fullUid, feature, type!);
            }

            // why is this here
            // if (popupInfo.oldType) {
            //     deleteFeatureShallow(fullUid, popupInfo.oldType);
            //     createFeatureShallow(fullUid, feature, type, popupInfo);
            // }

            updateFeature(fullUid, type!, patch, feature.geometry, popupInfo.oldType);
        } else {
            if (!feature) {
                console.error('No feature for New Entity');
            }
            createFeature(feature, type!, patch);
        }
        setTempFeatures([], null);
        toggleLayerVisibility(type!, LayerVisibility.visible);
        setEditing(false);
        setTimeout(() => closePopup());
    }, [
        //props
        databaseLayerIds, temporaryFeatures, originalFeature,
        //callbacks
        setEditing, setTempFeatures, toggleLayerVisibility, closePopup,
        createFeature, updateFeature,
        _replaceFeature,
    ])

    /* http  */

    return (
    <div className="mapContainer">
        <BufferModal
            show={showBuffer}
            onClose={() => {}}
            cancel={hideBuffer}
            complete={bufferTempFeature}
        />

        {showModal && <VerticalModal
            show={showModal}
            onClose={noop}
            cancel={closeModal}
            complete={confirmModal}
            completeButtonLabel={'Delete'}
            title={modalTitle}
            invalid={false}
            inputs={[]}
        />}

        <DataControls className='dataControl'
                      toggleLayers={toggleLayerList}
                      toggleTable={toggleTable}
                      toggleFeature={handleDataControlsFeatureClick}
                      editMode={editMode}
                      buffer={handleBuffer}
                      measure={handleMeasure}
                      isDrawing={isEditing}
                      isMeasuring={(isMeasuring)}
                      isEditingGeometry={isEditingGeometry}
                      showLayers={showLayerList}
                      showTable={showTable}
        />

        {mapStyle && <RightControls
            mapStyle={mapStyle}
            setSinglePoint={_setUserPoint}
            onViewportChange={onViewportChange}
            zoomIn={zoomIn}
            zoomOut={zoomOut}
            resetViewport={resetViewport}
            switchBasemap={switchBasemap}
            locateUser={locateUser}
            userLocation={userLocation}
            styleName={styleName}
        />}

        <Map
            /* props */
            mapStyle={mapStyle}
            sources={sources}
            styleName={styleName}
            viewport={viewport}
            isEditing={isEditing}
            isEditingPopup={isEditingPopup}
            isCreatingNewEntity={isCreatingNewEntity}
            isMeasuring={isMeasuring}
            layerState={layerState}
            layers={layers}
            databaseLayerIds={databaseLayerIds}
            interactiveLayerIds={interactiveLayerIds}
            measureFeatures={measureFeatures}
            temporaryFeatures={temporaryFeatures}
            userLocation={userLocation}
            popupInfo={popupInfo}
            /* callbacks */
            resize={resize}
            closePopup={closePopup}
            toggleEditing={toggleEditing}
            requestMapStyle={requestMapStyle}
            requestGeometry={requestGeometry}
            onViewportChange={onViewportChange}
            handleClick={handleClick}
            handleContextMenu={handleContextMenu}
            handleMeasureUpdate={handleMeasureUpdate}
            beginEditGeometry={beginEditGeometry}
            bufferExistingFeature={bufferExistingFeature}
            resetTempFeature={resetTempFeature}
            panToFeature={panToFeature}
            setTempFeatures={setTempFeatures}

            createContact={_createContact}
            createEntityContactLink={_createEntityContactLink}
            editContact={_editContact}
            updateFeature={_updateFeature}
            deleteFeature={_deleteFeature}
            removeEntityContactLink={_removeEntityContactLink}
            toggleLayerVisibility={toggleLayerVisibility}
            deleteLayer={deleteLayer}
            createLayer={createLayer}
            updateLayerName={updateLayerName}
        />

        {isEditing && <EditControls
            editMode={editMode}
            isEditingGeometry={isEditingGeometry}
            saveEnabled={geometryIsValid(temporaryFeatures)}
            message={geometryValidationMessage(temporaryFeatures)}
            cancel={cancelEditing}
            save={handleTempFeatureSave}
            query={handleTempFeatureQuery}
        />}

        {/*{(isMeasuring && !isEditing) && <MeasureControls*/}
        {/*    reset={resetMeasuring}*/}
        {/*    cancel={cancelMeasuring}*/}
        {/*/>}*/}

        {showLayerList && <LayerList key={'layerList'}
                    layers={sortedLayers}
                    layerState={layerState}
                    databaseLayerIds={databaseLayerIds}
                    deleteLayer={deleteLayer}
                    updateLayer={updateLayerName}
                    createLayer={createLayer}
                    sources={sources}
                    toggleLayer={toggleLayerVisibility}
                    panToFeature={panToFeature}
        />}

        {showTable && <div className="mapTableOverlay">
            <Table toggleTable={toggleTable} />
        </div>}

        <div className="envIcon public">
            <div>public</div>
            <div>
                <a className={'envHelp'} href={URL_CONFIG.helpUrl} rel="noreferrer" target="_blank">click for help</a>
            </div>
        </div>

        <div className="logoIcon">
            <a href={URL_CONFIG.logoUrl} target="_blank" rel="noreferrer">
                <img src={LOGO} alt="NAPD Logo"/>
            </a>
        </div>
    </div>);
}

export const ConnectedMapContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MapContainer);

export const ConnectedMapWithContext = (props: IProps) => {
    return (
        <ViewportProvider>
            <ConnectedMapContainer {...props} />
        </ViewportProvider>
    );
}

